import { render } from "./ContentDetailBunga.vue?vue&type=template&id=945833f2&scoped=true"
import script from "./ContentDetailBunga.vue?vue&type=script&lang=js"
export * from "./ContentDetailBunga.vue?vue&type=script&lang=js"

import "./ContentDetailBunga.vue?vue&type=style&index=0&id=945833f2&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945833f2"]])

export default __exports__